import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {withModal} from 'src/services/ModalService';
import {SuccessModal as _SuccessModal} from "src/components/modals/success/Success";

class SuccessModal extends Component {
    render () {
        const { modals, hideModal } = this.props;
        const { options } = modals;

        return ReactDOM.createPortal(
            <_SuccessModal
                show
                onClose={hideModal}
                title={options.title}
                children={options.children}
            />,
            document.getElementById('modals-content')
        );
    }
}

export default withModal(SuccessModal);
